module.exports = __webpack_public_path__ + "static/media/home1.66615fe2.png";